import { useGlobalStore } from '~/store/global'

export default function({route, redirect, env}) {
    const globalStore = useGlobalStore()
    if ('_storyblok' in route.query || globalStore.inStoryblok) globalStore.inStoryblok = true
    if (process.env.NODE_ENV.toLowerCase() !== 'production' || globalStore.inStoryblok || env.PREVIEW) return
    if (/^\/docs\/?/.test(route.path)) redirect('https://docs.getnacelle.com/')
}